require('./dist/initializeCanvas.js');
